/**
 * Spanish Contact Translations
 * 联系页翻译模块 - 西班牙语
 * 
 * 包含联系表单、联系信息、地图等翻译
 */

import type { ContactTranslations } from '../../types';

export const esContact: ContactTranslations = {
  title: 'Contáctenos',
  subtitle: 'Nos encantaría saber de ti.',
  header: {
    title: 'Contáctenos',
    subtitle: 'Nos encantaría saber de ti.',
  },
  form: {
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo Electrónico',
    interested: 'Producto de Interés',
    selectProduct: 'Seleccione',
    message: 'Mensaje',
    send: 'Enviar Mensaje',
    sending: 'Enviando...',
  },
  info: {
    headquarters: 'Sede Central',
    address: 'Edificio 25, Parque Científico y Tecnológico Wanyang, 26 Calle Tingwang, Pueblo Tingjiang, Distrito Mawei, Fuzhou, Fujian, China',
    phoneSupport: 'Soporte Telefónico',
    phone: '+86-15080458735',
    phoneHours: 'Lun-Vie 9am - 6pm (GMT+8)',
    emailUs: 'Escríbenos',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: 'Red de Distribuidores',
    distributorDesc: 'Estamos buscando distribuidores globales. Únetenos para llevar calefacción ecológica a tu país.',
  },
  success: {
    title: '¡Mensaje Enviado!',
    desc: 'Gracias por contactarnos. Nuestro equipo de ventas responderá dentro de 24 horas.',
    sendAnother: 'Enviar otro mensaje',
  },
};
